import { render, staticRenderFns } from "./selected_route.vue?vue&type=template&id=1f1284c5&"
import script from "./selected_route.vue?vue&type=script&lang=js&"
export * from "./selected_route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports